import { gridSize } from '@atlaskit/theme';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import { getReleaseVersion } from '../config';
import { getViewPortDimensions } from '../facade/window';
import { AnalyticsConsumerProps, withAnalytics } from '../hoc/withAnalytics';

import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import Products from './Products';

const gridSizeResult = gridSize();

type Props = {
  atlOrigin: string;
  utmSource: string;
} & AnalyticsConsumerProps;

@observer
class HomePage extends React.Component<Props> {
  componentDidMount() {
    const { atlOrigin, utmSource } = this.props;
    this.props.analytics.page('homeScreen', {
      atlOrigin,
      utmSource,
      ...getViewPortDimensions(),
      release: getReleaseVersion(),
    });
  }

  render() {
    return (
      <div data-testid="home-page-content">
        <PageTopMargin />
        <ErrorBoundary
          subject="products"
          onError={() => {
            // TODO: replace this with UFO
            // metrics.ui.endWithError(Task.PRODUCTS_ROW_LOADING, 'COMPONENT_BOUNDARY', 'errorBoundary');
          }}
        >
          <Products />
        </ErrorBoundary>
      </div>
    );
  }
}

const PageTopMargin = styled.div`
  padding-top: ${gridSizeResult * 4}px;
`;

export default withAnalytics(HomePage);
